import { Injectable } from '@angular/core';
import { MyHeader } from '../config/myHeader';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Correspondance } from '../models/Correspondance';

@Injectable({
  providedIn: 'any'
})
export class CorrespondanceService {
  constructor(private http:HttpClient) { }


  public getCorrespondances():Observable<Correspondance[]>{
    return this.http.get<Correspondance[]>(`${environment.urlBackend}correspondance/search?query=id>0&page=0&size=10&orderBy=id=desc,codeDivalto=ASC`);
  }

  public createCorrespondance(correspondance: Correspondance): Observable<Correspondance>{
    return this.http.post<Correspondance>(`${environment.urlBackend}correspondance`, correspondance);
  }

  public updateCorrespondance(correspondance: Correspondance): Observable<Correspondance>{
    return this.http.put<Correspondance>(`${environment.urlBackend}correspondance`, correspondance);
  }

  public getAllCorrepondance():Observable<Correspondance[]>{
    return this.http.get<Correspondance[]>(`${environment.urlBackend}correspondance`);

  }

  public deleteCorrespondance(correspondance: Correspondance){
    return this.http.delete(`${environment.urlBackend}correspondance?codeDivalto=` + correspondance.codeDivalto);
  }
}
